export default {
  featureMenuTitle: {
    id: 'FEATURE_MENU_TITLE',
    description: 'Title for the feature menu dropdown',
    defaultMessage: 'Feature Menu',
  },
};
